import { render, staticRenderFns } from "./modalGirarRuleta.vue?vue&type=template&id=1b990650&scoped=true"
import script from "./modalGirarRuleta.vue?vue&type=script&lang=js"
export * from "./modalGirarRuleta.vue?vue&type=script&lang=js"
import style0 from "./modalGirarRuleta.vue?vue&type=style&index=0&id=1b990650&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b990650",
  null
  
)

export default component.exports